/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// Fix scroll restoration bug
// https://stackoverflow.com/questions/55336831/how-to-fix-gatsby-js-link-component-retaining-scroll-position-and-not-resetting
//https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/#shouldUpdateScroll
exports.shouldUpdateScroll = (prevRouterProps, { location }) =>{

   if (location && !location.hash) {
    window.scrollTo(0, 0)
    const body = document.getElementsByTagName('body')[0]
    body.scrollTop = 0
    return false
  }

}




exports.onRouteUpdate = ({ location }) => scrollToAnchor(location)

/**
 *
 * @desc - a function to jump to the correct scroll position
 * @param {Object} location -
 * @param {Number} [mainNavHeight] - the height of any persistent nav -> document.querySelector(`nav`)
 */
//https://github.com/gatsbyjs/gatsby/issues/21120
function scrollToAnchor(location, mainNavHeight = 100) {

  // Check for location so build does not fail
  if (location && location.hash) {
    const item = document.querySelector(`${location.hash}`).offsetTop

    window.scrollTo({
      top: item - mainNavHeight,
      behavior: "smooth",
    })
  }
  return true
}

